import { Icon, IconNames } from 'atoms/Icon'
import { Background, BorderColors } from 'atoms/RadioButton/RadioButton.h'
import { RadioAccentMain } from 'atoms/RadioButton/Templates'
import { TextAligning } from 'atoms/TextBox'
import { TextBoxMaxLine1Footnote5 } from 'atoms/TextBox/Templates'
import { CardCorners } from 'blocks/Cards'
import { COLOR, FIXED_INDENTS } from 'vars/index'
import {
  PaymentCardSC,
  PaymentCardWrapper,
  PCWrapper,
} from './PopupComponents.styled'

export interface IPaymentCardComponent {
  paddings?: FIXED_INDENTS[]
  backgroundColor?: COLOR
  backgroundColorHovered?: COLOR
  backgroundColorPressed?: COLOR
  backgroundColorSelected?: COLOR
  backgroundColorSelectedHovered?: COLOR
  backgroundColorSelectedPressed?: COLOR
  selected?: boolean
  onClick?: () => void
  icon?: IconNames
  title?: string
  id: string
  corners?: CardCorners
}

export const PaymentCardComponent = ({
  paddings = [
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_140,
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_0,
  ],
  backgroundColor = COLOR.SURFACE_OPACITY_LIGHT_10,
  backgroundColorHovered = COLOR.SURFACE_OPACITY_LIGHT_15,
  backgroundColorPressed = COLOR.SURFACE_OPACITY_LIGHT_20,
  backgroundColorSelected = COLOR.ACCENT_PRIMARY_GRADIENT,
  backgroundColorSelectedHovered = COLOR.ACCENT_SECONDARY,
  backgroundColorSelectedPressed = COLOR.ACCENT_PRIMARY_PRESSED,
  selected,
  onClick,
  icon,
  title = '',
  id,
  corners = CardCorners.CORNERS_10,
}: IPaymentCardComponent) => {
  const isCard = icon || title?.split(' ')[0] === '****'

  return (
    <PaymentCardWrapper
      onClick={onClick}
      checked={selected ?? false}
      backgroundColor={backgroundColor}
      backgroundColorHovered={backgroundColorHovered}
      backgroundColorPressed={backgroundColorPressed}
      backgroundColorSelected={backgroundColorSelected}
      backgroundColorSelectedHovered={backgroundColorSelectedHovered}
      backgroundColorSelectedPressed={backgroundColorSelectedPressed}
      isActiveCard={true} // property for controlling the width of the card depending on the content; if value true - this is field select credit cards
      paddings={paddings}
      isCard={!!isCard}
      icon={!!icon}
    >
      {isCard ? (
        <>
          <RadioAccentMain
            checked={selected ?? false}
            id={id ?? Math.random().toString()}
            name={'Payment Option'}
            value={1}
            icon={IconNames.check}
            background={Background.SURFACE_OPACITY_DARK_40}
            backgroundChecked={Background.SURFACE_OPACITY_DARK_40}
            borderColor={BorderColors.SURFACE_OPACITY_LIGHT_10}
          />
          <PCWrapper>
            <PaymentCardSC paddings={paddings} corners={corners}>
              {icon ? <Icon name={icon} /> : <span />}
              <TextBoxMaxLine1Footnote5 title={title} />
            </PaymentCardSC>
          </PCWrapper>
        </>
      ) : (
        <PCWrapper>
          <PaymentCardSC paddings={paddings} corners={corners}>
            <TextBoxMaxLine1Footnote5
              title={title}
              alignment={TextAligning.Center}
            />
          </PaymentCardSC>
        </PCWrapper>
      )}
    </PaymentCardWrapper>
  )
}
